import { useQuery } from '@tanstack/react-query'
import { useCurrentNetwork } from '@mysten/dapp-kit-react'

import { useBackendClient } from '@/shared/kai/contexts/BackendClientContext'

export const positionMetricsHistoryQueryKey = (network: string, positionId: string) =>
  ['position-metrics-history', network, positionId] as const

export const usePositionMetricsHistory = (positionId: string) => {
  const network = useCurrentNetwork()

  const backendClient = useBackendClient()

  const result = useQuery({
    queryKey: positionMetricsHistoryQueryKey(network, positionId),
    queryFn: async () => {
      return await backendClient.positionsGetMetricsHistory(positionId)
    },
    refetchInterval: 5 * 60 * 1000, // 5 minutes
    staleTime: 10 * 60 * 1000, // 10 minutes
  })

  return {
    isLoading: result.isLoading,
    isError: result.isError,
    data: result.data,
  }
}
